// src/pages/Accounting/Reconcile/Session/sessionStorage.ts

import type { ColumnKey, Density } from "./sessionTypes";
import { DEFAULT_DENSITY, DEFAULT_VISIBLE_COLUMNS } from "./sessionTypes";

const TOUR_KEY = "novala.reconcile.tour.dismissed";
const COLUMNS_KEY = "novala.reconcile.session.columns";
const DENSITY_KEY = "novala.reconcile.session.density";

export function isTourDismissed(): boolean {
  try {
    return localStorage.getItem(TOUR_KEY) === "1";
  } catch {
    return false;
  }
}

export function setTourDismissed(dismissed: boolean): void {
  try {
    if (dismissed) {
      localStorage.setItem(TOUR_KEY, "1");
    } else {
      localStorage.removeItem(TOUR_KEY);
    }
  } catch {
    // best-effort
  }
}

export function loadVisibleColumns(): ColumnKey[] {
  try {
    const raw = localStorage.getItem(COLUMNS_KEY);
    if (!raw) return [...DEFAULT_VISIBLE_COLUMNS];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [...DEFAULT_VISIBLE_COLUMNS];
    return parsed.filter(
      (k): k is ColumnKey =>
        k === "clearedDate" ||
        k === "type" ||
        k === "refNo" ||
        k === "account" ||
        k === "payee" ||
        k === "memo"
    );
  } catch {
    return [...DEFAULT_VISIBLE_COLUMNS];
  }
}

export function saveVisibleColumns(cols: ColumnKey[]): void {
  try {
    localStorage.setItem(COLUMNS_KEY, JSON.stringify(cols));
  } catch {
    // best-effort
  }
}

export function loadDensity(): Density {
  try {
    const raw = localStorage.getItem(DENSITY_KEY);
    if (raw === "regular" || raw === "compact" || raw === "ultra") return raw;
    return DEFAULT_DENSITY;
  } catch {
    return DEFAULT_DENSITY;
  }
}

export function saveDensity(density: Density): void {
  try {
    localStorage.setItem(DENSITY_KEY, density);
  } catch {
    // best-effort
  }
}